import * as React from 'react';
import { useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Paper,
  Grid,
  Select,
  MenuItem,
} from '@mui/material';

const ExternalApiGeneric = () => {
  // Manage state for these fields in a real application
  const [url, setUrl] = React.useState('https://api.vendor.com/cleanse');
  const [authHeader, setAuthHeader] = React.useState('Authorization: Bearer {{secret}}');
  const [requestBody, setRequestBody] = React.useState(
    `{ "value": "{{Customer.Email}}", "country": "{{Customer.Country}}" }`
  );
  const [responseJsonPath, setResponseJsonPath] = React.useState('$.cleanedValue');
      const [method, setMethod] = useState('POST');

  // Handlers for input changes (implement as needed)
  const handleUrlChange = (event) => setUrl(event.target.value);
  const handleAuthHeaderChange = (event) => setAuthHeader(event.target.value);
  const handleRequestBodyChange = (event) => setRequestBody(event.target.value);
  const handleResponseJsonPathChange = (event) => setResponseJsonPath(event.target.value);

  const handleChange = (event) => {
    setMethod(event.target.value);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Paper elevation={1} sx={{ p: 4, flexGrow: 1 }}>
        <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
          HTTP Settings
        </Typography>

        <Grid container spacing={4}>
          {/* Left Column: URL, Method, Request Body, Response JSONPath */}
          <Grid item xs={12} md={8}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: 'medium' }}>
                URL
              </Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                value={url}
                onChange={handleUrlChange}
              />
            </Box>

            <Box sx={{ mb: 3 }}>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: 'medium' }}>
                Method & Auth Header
              </Typography>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Select
                  value={method}
                  label="Method"
                  onChange={handleChange}
                  sx={{ textTransform: 'uppercase' }}
                >
                  <MenuItem value="GET">GET</MenuItem>
                  <MenuItem value="POST">POST</MenuItem>
                  <MenuItem value="PUT">PUT</MenuItem>
                  <MenuItem value="PATCH">PATCH</MenuItem>
                  <MenuItem value="DELETE">DELETE</MenuItem>
                </Select>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={authHeader}
                  onChange={handleAuthHeaderChange}
                  label="Auth Header" // Add a label or use as placeholder
                  placeholder="Authorization: Bearer {{secret}}"
                />
              </Box>
            </Box>

            <Box sx={{ mb: 3 }}>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: 'medium' }}>
                Request Body Template (JSON)
              </Typography>
              {/* Textarea for JSON Request Body */}
              <TextField
                multiline
                rows={4} // Adjust rows as needed
                fullWidth
                value={requestBody}
                onChange={handleRequestBodyChange}
                InputProps={{
                  sx: {
                    fontFamily: 'monospace',
                    borderRadius: 1,
                  },
                }}
                sx={{
                  bgcolor: '#fcfcfc', // Slightly lighter background for the code block
                }}
              />
            </Box>

            <Box>
              <Typography variant="body1" sx={{ mb: 1, fontWeight: 'medium' }}>
                Response JSONPath to Output
              </Typography>
              <TextField
                variant="outlined"
                size="small"
                fullWidth
                value={responseJsonPath}
                onChange={handleResponseJsonPathChange}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper variant="outlined" sx={{ p: 2, height: 'fit-content', bgcolor: '#fcfcfc' }}>
              <Typography variant="body2" sx={{ mb: 0.5, fontWeight: 'bold' }}>
                Timeout: 3s
              </Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                Retries: 2
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default ExternalApiGeneric;